import { Helmet } from 'react-helmet-async';

// Canonical/OG URLs are pinned to the prod origin on purpose: the demo site
// then canonicalises to prod instead of competing with it in search.
const ORIGIN = 'https://scrabbledaily.com';
const OG_IMAGE = `${ORIGIN}/og-image.png`;

interface SeoProps {
  title: string;
  description: string;
  /** Path of the canonical URL, e.g. "/" or "/about". */
  path: string;
  /** Optional schema.org JSON-LD payload (object or array). */
  jsonLd?: unknown;
}

/** Per-route head tags (title/description/canonical/OG/Twitter/JSON-LD).
 *  Rendered by the indexable pages; the prerender step bakes the output into
 *  static HTML so crawlers and social scrapers see it without running JS. */
export function Seo({ title, description, path, jsonLd }: SeoProps) {
  const url = `${ORIGIN}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Scrabble Daily" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />
      {jsonLd ? <script type="application/ld+json">{JSON.stringify(jsonLd)}</script> : null}
    </Helmet>
  );
}
